module.exports = __webpack_public_path__ + "img/smart_home.e5add096.svg";